import fileDoc from 'jukun-ui-standard/dist-css/assets/file-icons/file-doc.svg';
import fileDwg from 'jukun-ui-standard/dist-css/assets/file-icons/file-dwg.svg';
import fileGlb from 'jukun-ui-standard/dist-css/assets/file-icons/file-glb.svg';
import fileIfc from 'jukun-ui-standard/dist-css/assets/file-icons/file-ifc.svg';
import fileImage from 'jukun-ui-standard/dist-css/assets/file-icons/file-image.svg';
import fileOther from 'jukun-ui-standard/dist-css/assets/file-icons/file-other.svg';
import filePdf from 'jukun-ui-standard/dist-css/assets/file-icons/file-pdf.svg';
import filePpt from 'jukun-ui-standard/dist-css/assets/file-icons/file-ppt.svg';
import fileSap from 'jukun-ui-standard/dist-css/assets/file-icons/file-sap.svg';
import fileXls from 'jukun-ui-standard/dist-css/assets/file-icons/file-xls.svg';

export const standardFileIconAssets = {
  word: fileDoc,
  dwg: fileDwg,
  glb: fileGlb,
  ifc: fileIfc,
  image: fileImage,
  other: fileOther,
  pdf: filePdf,
  ppt: filePpt,
  sap: fileSap,
  excel: fileXls,
} as const;
